import type { ActivityEntry } from "../types";
import { Icon } from "./Icon";

interface AgentPanelProps {
  activity: ActivityEntry[];
}

function relativeTime(iso: string): string {
  const seconds = Math.max(0, Math.round((Date.now() - Date.parse(iso)) / 1000));
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return new Intl.DateTimeFormat("en", { month: "short", day: "numeric" }).format(new Date(iso));
}

export function AgentPanel({ activity }: AgentPanelProps) {
  return (
    <section className="agent-panel" aria-labelledby="agent-panel-title">
      <div className="agent-panel-heading">
        <div><h2 id="agent-panel-title">Activity</h2><p>Changes made in this browser.</p></div>
        <Icon name="clock" size={20} />
      </div>
      <div className="activity-list">
        <div className="activity-label"><strong>Recent changes</strong><span>{activity.length ? `${activity.length} local` : "None yet"}</span></div>
        {activity.slice(0, 6).map((entry) => (
          <article key={entry.id} className="activity-entry">
            <span className={`activity-source source-${entry.source}`}><Icon name={entry.source === "agent" ? "spark" : "user"} size={14} />{entry.source === "agent" ? "Agent" : "You"}</span>
            <span className="activity-copy"><strong>{entry.action}</strong><small>{entry.detail}</small></span>
            <time dateTime={entry.at}>{relativeTime(entry.at)}</time>
          </article>
        ))}
        {!activity.length ? <p className="activity-empty">Changes from you and your agent will appear here.</p> : null}
      </div>
    </section>
  );
}
